<template>
  <div class="TabacCarnetDuFumeurS1PatientReport">
    <img src="/tabac/tabac-vignette-rapport.png" style="width: 100%; margin-bottom: 20px"/>

    <div style="color: black">
      <div style="font-size: 25px">Mon carnet du fumeur | <b>{{ report.data.patient.first_name }} {{ report.data.patient.last_name }}</b></div>
      <hr class="mb-1"/>
    </div>

    <div class="my-12" v-if="isWeek(1)">
      <h1>Semaine 1</h1>
      <hr class="mb-1"/>

      <div>
        <h2>La balance décisionnelle</h2>
        <hr class="mb-1"/>
        <div>
          <v-simple-table>
            <thead>
            <tr>
              <th style="width:45%">Pourquoi je veux arrêter de fumer ?</th>
              <th style="width:45%">Pourquoi je voudrais continuer ?</th>
              <th style="width:10%">Modifier <v-icon>create</v-icon></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in report.data.s1_1_ballance_decisionnelle">
              <td v-if="ballance_decisionnelle.id !== data.id">{{data.arreter}}</td>
              <td v-if="ballance_decisionnelle.id !== data.id">{{data.continuer}}</td>
              <td v-if="ballance_decisionnelle.id !== data.id"><v-icon @click="() => { ballance_decisionnelle.id = data.id; ballance_decisionnelle.arreter = data.arreter; ballance_decisionnelle.continuer = data.continuer; }">create</v-icon></td>
              <td v-if="ballance_decisionnelle.id === data.id"><v-text-field v-model="ballance_decisionnelle.arreter"/></td>
              <td v-if="ballance_decisionnelle.id === data.id"><v-text-field v-model="ballance_decisionnelle.continuer"/></td>
              <td v-if="ballance_decisionnelle.id === data.id"><v-btn :loading="ballance_decisionnelle.loading" @click="saveBallanceDecisionnelle">Enregistrer</v-btn><v-btn @click="clearBallanceDecisionnelle">Annuler</v-btn></td>
            </tr>
            <tr>
              <td><v-text-field v-model="ballance_decisionnelle.create.arreter"/></td>
              <td><v-text-field v-model="ballance_decisionnelle.create.continuer"/></td>
              <td style="display: flex; flex-direction: column"><v-btn @click="createBallanceDecisionnelle">Nouveau</v-btn><v-btn @click="clearBallanceDecisionnelle">Annuler</v-btn></td>
            </tr>
            </tbody>
          </v-simple-table>
        </div>
      </div>

      <div>
        <h2>La respiration ventrale</h2>
        <hr class="mb-1"/>
        <IriadeApplicationMediaBlock :block="{ config: { media: report.data.s1_2_respiration_ventrale } }"></IriadeApplicationMediaBlock>
      </div>

      <div>
        <h2>La liste de mes envies</h2>
        <hr class="mb-1"/>
        <div>
          <v-textarea v-model="liste_envies" outlined/>
          <div class="flex-row"><v-btn class="mr-4" :disabled="liste_envies === report.data.s1_3_liste_envies" @click="saveListeEnvies">Enregistrer</v-btn><v-btn :disabled="liste_envies === report.data.s1_3_liste_envies" @click="clearListeEnvies">Annuler</v-btn></div>
        </div>
      </div>
    </div>

    <div class="my-12" v-if="isWeek(2)">
      <h1>Semaine 2</h1>
      <hr class="mb-1"/>

      <div>
        <h2>J'observe la consommation d'une cigarette par mes 5 sens</h2>
        <hr class="mb-1"/>
        <div>
          <v-simple-table>
            <thead>
            <tr>
              <th style="width:30%">Expériences agréables ou non et comportements</th>
              <th style="width:30%">Sensations corporelles/Émotions</th>
              <th style="width:30%">Pensées/Humeurs/Sentiments</th>
              <th style="width:10%">Modifier <v-icon>create</v-icon></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in report.data.s2_1_jobserve_consommation_5sens">
              <td v-if="consommation_5sens.id !== data.id">{{data.experiences}}</td>
              <td v-if="consommation_5sens.id !== data.id">{{data.sensations}}</td>
              <td v-if="consommation_5sens.id !== data.id">{{data.pensees}}</td>
              <td v-if="consommation_5sens.id !== data.id"><v-icon @click="() => { consommation_5sens.id = data.id; consommation_5sens.experiences = data.experiences; consommation_5sens.sensations = data.sensations; consommation_5sens.pensees = data.pensees; }">create</v-icon></td>
              <td v-if="consommation_5sens.id === data.id"><v-text-field v-model="consommation_5sens.experiences"/></td>
              <td v-if="consommation_5sens.id === data.id"><v-text-field v-model="consommation_5sens.sensations"/></td>
              <td v-if="consommation_5sens.id === data.id"><v-text-field v-model="consommation_5sens.pensees"/></td>
              <td v-if="consommation_5sens.id === data.id"><v-btn :loading="consommation_5sens.loading" @click="saveConsommation5Sens">Enregistrer</v-btn><v-btn :loading="consommation_5sens.loading" @click="clearConsommation5Sens">Annuler</v-btn></td>
            </tr>
            <tr>
              <td><v-text-field v-model="consommation_5sens.create.experiences"/></td>
              <td><v-text-field v-model="consommation_5sens.create.sensations"/></td>
              <td><v-text-field v-model="consommation_5sens.create.pensees"/></td>
              <td style="display: flex; flex-direction: column"><v-btn @click="createConsommation5Sens">Nouveau</v-btn><v-btn @click="clearConsommation5Sens">Annuler</v-btn></td>
            </tr>
            </tbody>
          </v-simple-table>
        </div>
      </div>

      <div>
        <h2>Je me projette en tant qu’ex-fumeur</h2>
        <hr class="mb-1"/>
        <div>
          <v-textarea v-model="projette_ex_fumeur" outlined/>
          <div class="flex-row"><v-btn class="mr-4" :disabled="projette_ex_fumeur === report.data.s2_2_projetteExFumeur" @click="saveProjetteExFumeur">Enregistrer</v-btn><v-btn :disabled="projette_ex_fumeur === report.data.s2_2_projetteExFumeur" @click="clearProjetteExFumeur">Annuler</v-btn></div>
        </div>
      </div>
    </div>

    <div class="my-12" v-if="isWeek(3)">
      <h1>Semaine 3</h1>
      <hr class="mb-1"/>

      <div>
        <h2>J'experimente la pulsion d'envie</h2>
        <hr class="mb-1"/>
        <div>
          <v-simple-table>
            <thead>
            <tr>
              <th style="width:30%">Expériences agréables ou non et comportements</th>
              <th style="width:30%">Sensations corporelles/Émotions</th>
              <th style="width:30%">Pensées/Humeurs/Sentiments</th>
              <th style="width:10%">Modifier <v-icon>create</v-icon></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in report.data.s3_1_jexperimentePulsionsDenvie">
              <td v-if="jexperimente_pulsion_denvie.id !== data.id">{{data.experiences}}</td>
              <td v-if="jexperimente_pulsion_denvie.id !== data.id">{{data.sensations}}</td>
              <td v-if="jexperimente_pulsion_denvie.id !== data.id">{{data.pensees}}</td>
              <td v-if="jexperimente_pulsion_denvie.id !== data.id"><v-icon @click="() => { jexperimente_pulsion_denvie.id = data.id; jexperimente_pulsion_denvie.experiences = data.experiences; jexperimente_pulsion_denvie.sensations = data.sensations; jexperimente_pulsion_denvie.pensees = data.pensees; }">create</v-icon></td>
              <td v-if="jexperimente_pulsion_denvie.id === data.id"><v-text-field v-model="jexperimente_pulsion_denvie.experiences"/></td>
              <td v-if="jexperimente_pulsion_denvie.id === data.id"><v-text-field v-model="jexperimente_pulsion_denvie.sensations"/></td>
              <td v-if="jexperimente_pulsion_denvie.id === data.id"><v-text-field v-model="jexperimente_pulsion_denvie.pensees"/></td>
              <td v-if="jexperimente_pulsion_denvie.id === data.id"><v-btn :loading="jexperimente_pulsion_denvie.loading" @click="saveJExperimentePulsionDEnvie">Enregistrer</v-btn><v-btn :loading="jexperimente_pulsion_denvie.loading" @click="clearJExperimentePulsionDEnvie">Annuler</v-btn></td>
            </tr>
            <tr>
              <td><v-text-field v-model="jexperimente_pulsion_denvie.create.experiences"/></td>
              <td><v-text-field v-model="jexperimente_pulsion_denvie.create.sensations"/></td>
              <td><v-text-field v-model="jexperimente_pulsion_denvie.create.pensees"/></td>
              <td style="display: flex; flex-direction: column"><v-btn @click="createJExperimentePulsionDEnvie">Nouveau</v-btn><v-btn @click="clearJExperimentePulsionDEnvie">Annuler</v-btn></td>
            </tr>
            </tbody>
          </v-simple-table>
        </div>
      </div>
    </div>

    <div class="my-12" v-if="isWeek(4)">
      <h1>Semaine 4</h1>
      <hr class="mb-1"/>

      <div>
        <h2>Mes qualités pour arrêter de fumer</h2>
        <hr class="mb-1"/>
        <div>
          <v-textarea v-model="qualite_arreter_fumer" outlined/>
          <div class="flex-row"><v-btn class="mr-4" :disabled="qualite_arreter_fumer === report.data.s4_1_qualitesArreterFumer" @click="saveQualiteArreterFumer">Enregistrer</v-btn><v-btn :disabled="qualite_arreter_fumer === report.data.s4_1_qualitesArreterFumer" @click="clearQualiteArreterFumer">Annuler</v-btn></div>
        </div>
      </div>
    </div>

    <div class="my-12" v-if="isWeek(5)">
      <h1>Semaine 5</h1>
      <hr class="mb-1"/>

      <div>
        <h2>Pas de freins pour s'arrêter !</h2>
        <hr class="mb-1"/>
        <div>
          <v-textarea v-model="freins_pour_arreter" outlined/>
          <div class="flex-row"><v-btn class="mr-4" :disabled="freins_pour_arreter === report.data.s5_1_freinsPourArreter" @click="saveFreinPourArreter">Enregistrer</v-btn><v-btn :disabled="freins_pour_arreter === report.data.s5_1_freinsPourArreter" @click="clearFreinPourArreter">Annuler</v-btn></div>
        </div>
      </div>
    </div>

    <div class="my-12" v-if="isWeek(7)">
      <h1>Semaine 7</h1>
      <hr class="mb-1"/>

      <div>
        <h2>Le jeu des 3 mercis</h2>
        <hr class="mb-1"/>
        <div>
          <v-simple-table>
            <thead>
            <tr>
              <th style="width:30%">Je m’entraine à trouver 3 choses positives/jour et à dire 3 mercis/jour</th>
              <th style="width:10%">Modifier <v-icon>create</v-icon></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in report.data.s7_1_jeu3Mercis">
              <td v-if="jeu_3_mercis.id !== data.id">{{data.mercis}}</td>
              <td v-if="jeu_3_mercis.id !== data.id"><v-icon @click="() => { jeu_3_mercis.id = data.id; jeu_3_mercis.mercis = data.mercis; }">create</v-icon></td>
              <td v-if="jeu_3_mercis.id === data.id"><v-text-field v-model="jeu_3_mercis.mercis"/></td>
              <td v-if="jeu_3_mercis.id === data.id"><v-btn :loading="jeu_3_mercis.loading" @click="saveJeu3Mercis">Enregistrer</v-btn><v-btn :loading="jeu_3_mercis.loading" @click="clearJeu3Mercis">Annuler</v-btn></td>
            </tr>
            <tr>
              <td><v-text-field v-model="jeu_3_mercis.create.mercis"/></td>
              <td style="display: flex; flex-direction: column"><v-btn @click="createJeu3Mercis">Nouveau</v-btn><v-btn @click="clearJeu3Mercis">Annuler</v-btn></td>
            </tr>
            </tbody>
          </v-simple-table>
        </div>
      </div>
      <div>
        <h2>Je décortique une cigarette et je découvre l’intérieur au travers de mes 3 sens</h2>
        <hr class="mb-1"/>
        <div>
          <v-textarea v-model="decortique_experience" outlined/>
          <div class="flex-row"><v-btn class="mr-4" :disabled="decortique_experience === report.data.s7_2_decortiqueExperience" @click="saveDecortiqueExperience">Enregistrer</v-btn><v-btn :disabled="decortique_experience === report.data.s7_2_decortiqueExperience" @click="clearDecortiqueExperience">Annuler</v-btn></div>
        </div>
      </div>
    </div>

    <div class="my-12" v-if="isWeek(8)">
      <h1>Semaine 8</h1>
      <hr class="mb-1"/>

      <div>
        <h2>Quels sont les lieux, les gens les moments que j’associe ou que j’associais à une cigarette ?</h2>
        <hr class="mb-1"/>
        <div>
          <v-textarea v-model="associations" outlined/>
          <div class="flex-row"><v-btn class="mr-4" :disabled="associations === report.data.s8_1_associations" @click="saveAssociations">Enregistrer</v-btn><v-btn :disabled="associations === report.data.s8_1_associations" @click="clearAssociations">Annuler</v-btn></div>
        </div>
      </div>
    </div>

    <div class="my-12" v-if="isWeek(9)">
      <h1>Semaine 9</h1>
      <hr class="mb-1"/>

      <div>
        <h2>Comment j’envisage ma nouvelle pause au travail après l’arrêt du tabac ?</h2>
        <hr class="mb-1"/>
        <div>
          <v-textarea v-model="pause_travail" outlined/>
          <div class="flex-row"><v-btn class="mr-4" :disabled="pause_travail === report.data.s9_1_pause_travail" @click="savePauseTravail">Enregistrer</v-btn><v-btn :disabled="pause_travail === report.data.s9_1_pause_travail" @click="clearPauseTravail">Annuler</v-btn></div>
        </div>
      </div>
    </div>

    <div class="my-12" v-if="isWeek(10)">
      <h1>Semaine 10</h1>
      <hr class="mb-1"/>

      <div>
        <h2>Comment je gère une soirée en pleine conscience</h2>
        <hr class="mb-1"/>
        <div>
          <v-textarea v-model="soiree_pleine_conscience" outlined/>
          <div class="flex-row"><v-btn class="mr-4" :disabled="soiree_pleine_conscience === report.data.s10_1_soiree_pleine_conscience" @click="saveSoireePleineConscience">Enregistrer</v-btn><v-btn :disabled="soiree_pleine_conscience === report.data.s10_1_soiree_pleine_conscience" @click="clearSoireePleineConscience">Annuler</v-btn></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import api from 'api'
import moment from 'moment';
import IriadeApplicationMediaBlock from "components/Iriade/Blocks/IriadeApplicationMediaBlock/IriadeApplicationMediaBlock";


export default {
  components: {
    IriadeApplicationMediaBlock
  },

  data() {
    return {
      ballance_decisionnelle: {
        loading: false,
        id: null,
        arreter: null,
        continuer: null,
        create: {
          arreter: null,
          continuer: null,
        }
      },
      liste_envies: null,

      consommation_5sens: {
        loading: false,
        id: null,
        experiences: null,
        sensations: null,
        pensees: null,
        create: {
          experiences: null,
          sensations: null,
          pensees: null,
        }
      },
      projette_ex_fumeur: null,

      jexperimente_pulsion_denvie: {
        loading: false,
        id: null,
        experiences: null,
        sensations: null,
        pensees: null,
        create: {
          experiences: null,
          sensations: null,
          pensees: null,
        }
      },

      qualite_arreter_fumer: null,

      freins_pour_arreter: null,

      jeu_3_mercis: {
        loading: false,
        id: null,
        mercis: null,
        create: {
          mercis: null,
        }
      },
      decortique_experience: null,

      associations: null,

      pause_travail: null,

      soiree_pleine_conscience: null,
    }
  },

  computed: {

  },

  methods: {
    isWeek(week) {
      switch(week) {
        case 1:
          return moment().isAfter(moment('2024-06-10'));
        case 2:
          return moment().isAfter(moment('2024-06-17'));
        case 3:
          return moment().isAfter(moment('2024-06-24'));
        case 4:
          return moment().isAfter(moment('2024-07-01'));
        case 5:
          return moment().isAfter(moment('2024-07-08'));
        case 6:
          return moment().isAfter(moment('2024-07-15'));
        case 7:
          return moment().isAfter(moment('2024-07-22'));
        case 8:
          return moment().isAfter(moment('2024-07-29'));
        case 9:
          return moment().isAfter(moment('2024-08-05'));
        case 10:
          return moment().isAfter(moment('2024-08-12'));
      }
    },

    createBallanceDecisionnelle() {
      this.ballance_decisionnelle.loading = true;
      api.post(`tabac/carnetS1/ballanceDecisionnelle/create/${this.report.patient.id}`, this.ballance_decisionnelle.create)
        .then(res => {
          this.$mango.snackbar({
            color: 'success',
            text: "Modifications enregistrées.",
          });
          Vue.set(this.report.data, 's1_1_ballance_decisionnelle', res.data);
        })
        .catch(_ => {
          this.$mango.snackbar({
            color: 'error',
            text: "Une erreur est survenue."
          });
        })
        .finally(_ => {
          this.clearBallanceDecisionnelle();
        })
    },

    saveBallanceDecisionnelle() {
      api.post(`tabac/carnetS1/ballanceDecisionnelle/update/${this.ballance_decisionnelle.id}`, this.ballance_decisionnelle)
        .then(res => {
          this.$mango.snackbar({
            color: 'success',
            text: "Modifications enregistrées.",
          });
          Vue.set(this.report.data, 's1_1_ballance_decisionnelle', res.data);
        })
        .catch(_ => {
          this.$mango.snackbar({
            color: 'error',
            text: "Une erreur est survenue."
          });
        })
        .finally(_ => {
          this.clearBallanceDecisionnelle();
        })
    },

    clearBallanceDecisionnelle() {
      this.ballance_decisionnelle.loading = false;
      this.ballance_decisionnelle.id = null;
      this.ballance_decisionnelle.arreter = null;
      this.ballance_decisionnelle.continuer = null;
      this.ballance_decisionnelle.create = {
        arreter: null,
        continuer: null,
      };
    },

    saveListeEnvies() {
      api.post(`tabac/carnetS1/listeEnvies/${this.report.patient.id}`, {liste: this.liste_envies})
        .then(res => {
          this.$mango.snackbar({
            color: 'success',
            text: "Modifications enregistrées.",
          });
          Vue.set(this.report.data, 's1_3_liste_envies', res.data);
        })
        .catch(_ => {
          this.$mango.snackbar({
            color: 'error',
            text: "Une erreur est survenue."
          });
        })
        .finally(_ => {
          this.clearListeEnvies();
        })
    },

    clearListeEnvies() {
      this.liste_envies = this.report.data.s1_3_liste_envies;
    },

    createConsommation5Sens() {
      this.consommation_5sens.loading = true;
      api.post(`tabac/carnetS1/jobserveConsommation5Sens/create/${this.report.patient.id}`, this.consommation_5sens.create)
        .then(res => {
          this.$mango.snackbar({
            color: 'success',
            text: "Modifications enregistrées.",
          });
          Vue.set(this.report.data, 's2_1_jobserve_consommation_5sens', res.data);
        })
        .catch(_ => {
          this.$mango.snackbar({
            color: 'error',
            text: "Une erreur est survenue."
          });
        })
        .finally(_ => {
          this.clearConsommation5Sens();
        })
    },

    saveConsommation5Sens() {
      api.post(`tabac/carnetS1/jobserveConsommation5Sens/update/${this.consommation_5sens.id}`, this.consommation_5sens)
        .then(res => {
          this.$mango.snackbar({
            color: 'success',
            text: "Modifications enregistrées.",
          });
          Vue.set(this.report.data, 's2_1_jobserve_consommation_5sens', res.data);
        })
        .catch(_ => {
          this.$mango.snackbar({
            color: 'error',
            text: "Une erreur est survenue."
          });
        })
        .finally(_ => {
          this.clearConsommation5Sens();
        })
    },

    clearConsommation5Sens() {
      this.consommation_5sens.loading = false;
      this.consommation_5sens.id = null;
      this.consommation_5sens.experiences = null;
      this.consommation_5sens.pensees = null;
      this.consommation_5sens.sensations = null;
      this.consommation_5sens.create = {
        pensees: null,
        sensations: null,
        experiences: null,
      };
    },

    saveProjetteExFumeur() {
      api.post(`tabac/carnetS1/projetteExFumeur/${this.report.patient.id}`, {projette: this.projette_ex_fumeur})
        .then(res => {
          this.$mango.snackbar({
            color: 'success',
            text: "Modifications enregistrées.",
          });
          Vue.set(this.report.data, 's2_2_projetteExFumeur', res.data);
        })
        .catch(_ => {
          this.$mango.snackbar({
            color: 'error',
            text: "Une erreur est survenue."
          });
        })
        .finally(_ => {
          this.clearProjetteExFumeur();
        })
    },

    clearProjetteExFumeur() {
      this.projette_ex_fumeur = this.report.data.s2_2_projetteExFumeur;
    },

    createJExperimentePulsionDEnvie() {
      this.consommation_5sens.loading = true;
      api.post(`tabac/carnetS1/jexperimente_pulsions_denvie/create/${this.report.patient.id}`, this.jexperimente_pulsion_denvie.create)
        .then(res => {
          this.$mango.snackbar({
            color: 'success',
            text: "Modifications enregistrées.",
          });
          Vue.set(this.report.data, 's3_1_jexperimentePulsionsDenvie', res.data);
        })
        .catch(_ => {
          this.$mango.snackbar({
            color: 'error',
            text: "Une erreur est survenue."
          });
        })
        .finally(_ => {
          this.clearJExperimentePulsionDEnvie();
        })
    },

    saveJExperimentePulsionDEnvie() {
      api.post(`tabac/carnetS1/jexperimente_pulsions_denvie/update/${this.jexperimente_pulsion_denvie.id}`, this.jexperimente_pulsion_denvie)
        .then(res => {
          this.$mango.snackbar({
            color: 'success',
            text: "Modifications enregistrées.",
          });
          Vue.set(this.report.data, 's3_1_jexperimentePulsionsDenvie', res.data);
        })
        .catch(_ => {
          this.$mango.snackbar({
            color: 'error',
            text: "Une erreur est survenue."
          });
        })
        .finally(_ => {
          this.clearJExperimentePulsionDEnvie();
        })
    },

    clearJExperimentePulsionDEnvie() {
      this.jexperimente_pulsion_denvie.loading = false;
      this.jexperimente_pulsion_denvie.id = null;
      this.jexperimente_pulsion_denvie.experiences = null;
      this.jexperimente_pulsion_denvie.pensees = null;
      this.jexperimente_pulsion_denvie.sensations = null;
      this.jexperimente_pulsion_denvie.create = {
        pensees: null,
        sensations: null,
        experiences: null,
      };
    },

    saveQualiteArreterFumer() {
      api.post(`tabac/carnetS1/qualite_arreter_fumer/${this.report.patient.id}`, {qualiteArreter: this.qualite_arreter_fumer})
        .then(res => {
          this.$mango.snackbar({
            color: 'success',
            text: "Modifications enregistrées.",
          });
          Vue.set(this.report.data, 's4_1_qualitesArreterFumer', res.data);
        })
        .catch(_ => {
          this.$mango.snackbar({
            color: 'error',
            text: "Une erreur est survenue."
          });
        })
        .finally(_ => {
          this.clearQualiteArreterFumer();
        })
    },

    clearQualiteArreterFumer() {
      this.qualite_arreter_fumer = this.report.data.s4_1_qualitesArreterFumer;
    },

    saveFreinPourArreter() {
      api.post(`tabac/carnetS1/freins_pour_arreter/${this.report.patient.id}`, {freinsPourArreter: this.freins_pour_arreter})
        .then(res => {
          this.$mango.snackbar({
            color: 'success',
            text: "Modifications enregistrées.",
          });
          Vue.set(this.report.data, 's5_1_freinsPourArreter', res.data);
        })
        .catch(_ => {
          this.$mango.snackbar({
            color: 'error',
            text: "Une erreur est survenue."
          });
        })
        .finally(_ => {
          this.clearFreinPourArreter();
        })
    },

    clearFreinPourArreter() {
      this.freins_pour_arreter = this.report.data.s5_1_freinsPourArreter;
    },

    createJeu3Mercis() {
      this.consommation_5sens.loading = true;
      api.post(`tabac/carnetS1/jeu_3_mercis/create/${this.report.patient.id}`, this.jeu_3_mercis.create)
        .then(res => {
          this.$mango.snackbar({
            color: 'success',
            text: "Modifications enregistrées.",
          });
          Vue.set(this.report.data, 's7_1_jeu3Mercis', res.data);
        })
        .catch(_ => {
          this.$mango.snackbar({
            color: 'error',
            text: "Une erreur est survenue."
          });
        })
        .finally(_ => {
          this.clearJeu3Mercis();
        })
    },

    saveJeu3Mercis() {
      api.post(`tabac/carnetS1/jeu_3_mercis/update/${this.jeu_3_mercis.id}`, this.jeu_3_mercis)
        .then(res => {
          this.$mango.snackbar({
            color: 'success',
            text: "Modifications enregistrées.",
          });
          Vue.set(this.report.data, 's7_1_jeu3Mercis', res.data);
        })
        .catch(_ => {
          this.$mango.snackbar({
            color: 'error',
            text: "Une erreur est survenue."
          });
        })
        .finally(_ => {
          this.clearJeu3Mercis();
        })
    },

    clearJeu3Mercis() {
      this.jeu_3_mercis.loading = false;
      this.jeu_3_mercis.id = null;
      this.jeu_3_mercis.mercis = null;
      this.jeu_3_mercis.create = {
        mercis: null,
      };
    },

    saveDecortiqueExperience() {
      api.post(`tabac/carnetS1/decortique_experience/${this.report.patient.id}`, {decortiqueExperience: this.decortique_experience})
        .then(res => {
          this.$mango.snackbar({
            color: 'success',
            text: "Modifications enregistrées.",
          });
          Vue.set(this.report.data, 's7_2_decortiqueExperience', res.data);
        })
        .catch(_ => {
          this.$mango.snackbar({
            color: 'error',
            text: "Une erreur est survenue."
          });
        })
        .finally(_ => {
          this.clearDecortiqueExperience();
        })
    },

    clearDecortiqueExperience() {
      this.decortique_experience = this.report.data.s7_2_decortiqueExperience;
    },

    saveAssociations() {
      api.post(`tabac/carnetS1/associations/${this.report.patient.id}`, {associations: this.associations})
        .then(res => {
          this.$mango.snackbar({
            color: 'success',
            text: "Modifications enregistrées.",
          });
          Vue.set(this.report.data, 's8_1_associations', res.data);
        })
        .catch(_ => {
          this.$mango.snackbar({
            color: 'error',
            text: "Une erreur est survenue."
          });
        })
        .finally(_ => {
          this.clearAssociations();
        })
    },

    clearAssociations() {
      this.associations = this.report.data.s8_1_associations;
    },

    savePauseTravail() {
      api.post(`tabac/carnetS1/pause_travail/${this.report.patient.id}`, {pause_travail: this.pause_travail})
        .then(res => {
          this.$mango.snackbar({
            color: 'success',
            text: "Modifications enregistrées.",
          });
          Vue.set(this.report.data, 's9_1_pause_travail', res.data);
        })
        .catch(_ => {
          this.$mango.snackbar({
            color: 'error',
            text: "Une erreur est survenue."
          });
        })
        .finally(_ => {
          this.clearPauseTravail();
        })
    },

    clearPauseTravail() {
      this.pause_travail = this.report.data.s9_1_pause_travail;
    },

    saveSoireePleineConscience() {
      api.post(`tabac/carnetS1/soiree_pleine_conscience/${this.report.patient.id}`, {soireepleineConscience: this.soiree_pleine_conscience})
        .then(res => {
          this.$mango.snackbar({
            color: 'success',
            text: "Modifications enregistrées.",
          });
          Vue.set(this.report.data, 's10_1_soiree_pleine_conscience', res.data);
        })
        .catch(_ => {
          this.$mango.snackbar({
            color: 'error',
            text: "Une erreur est survenue."
          });
        })
        .finally(_ => {
          this.clearSoireePleineConscience();
        })
    },

    clearSoireePleineConscience() {
      this.soiree_pleine_conscience = this.report.data.s10_1_soiree_pleine_conscience;
    },
  },

  mounted() {
    this.liste_envies = this.report.data.s1_3_liste_envies;
    this.projette_ex_fumeur = this.report.data.s2_2_projetteExFumeur;
    this.qualite_arreter_fumer = this.report.data.s4_1_qualitesArreterFumer;
    this.freins_pour_arreter = this.report.data.s5_1_freinsPourArreter;
    this.decortique_experience = this.report.data.s7_2_decortiqueExperience;
    this.associations = this.report.data.s8_1_associations;
    this.pause_travail = this.report.data.s9_1_pause_travail;
    this.soiree_pleine_conscience = this.report.data.s10_1_soiree_pleine_conscience;
  },

  props: {
    report: {
      required: true,
      type: Object
    }
  }
}
</script>

<style lang="scss"
       type="text/scss">
.TabacCarnetDuFumeurS1PatientReport {
  font-size: 16px;

  .BlocQR {
    margin-bottom: 25px;
  }

  .Reponse {
    font-weight: bold;
    margin-left: 10px;
  }

  .Question {
  }

  .imgSlot {
    position: relative;
    margin-bottom: 20px;
  }

  .thumbnail {
    width: 153px;
    height: 224px;
  }

  .fullSize {
    object-fit: scale-down;
    min-width: 54vh;
    height: 96vh;
    width: auto;
    margin: 0px 5px;
  }

  .tooltip {
    position: relative;
    display: inline-block;
    border-bottom: 1px dotted black;
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    left: 50%;
    margin-left: -60px;
    opacity: 0;
    transition: opacity 0.3s;
  }

  .tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }
}
</style>
